import { createFileRoute } from '@tanstack/react-router'
import { useUserSettingsStore } from '@zendia/frontend-shared'
import { ProfileSettingsPage } from '../../../components/Settings/ProfileSettingsPage'
import { useAutoSaveSettings } from '../../../components/Settings/useAutoSaveSettings'
import LifeDomainAlignmentForm from '../../../screens/onboarding/forms/LifeDomainAlignmentForm'
import { lifeDomainsFromAllocation } from '../../../utilities/lifeDomainSettings'

export const Route = createFileRoute('/_authenticated/settings/life-balance')({
  component: LifeBalanceSettings,
})

function LifeBalanceSettings() {
  const { settings: userSettings } = useUserSettingsStore()
  const { save, retry, status } = useAutoSaveSettings()

  // Satisfaction ratings live on the same entries, so they are carried over rather than lost.
  const onSubmit = (allocation: Record<string, number>) =>
    save({ lifeDomains: lifeDomainsFromAllocation(allocation, userSettings?.lifeDomains) })

  return (
    <ProfileSettingsPage
      title="Life balance"
      description="How you want your week shared across your life domains. Each block is 5% of your week."
      saveStatus={status}
      onRetry={retry}
    >
      <LifeDomainAlignmentForm onSubmit={onSubmit} autoSave />
    </ProfileSettingsPage>
  )
}
